.divider {
  margin: 0;
  flex-shrink: 0;
  border: none;
  border-bottom: thin solid var(--tuna-palette-divider);
}

.vertical {
  border-bottom: none;
  border-right: thin solid var(--tuna-palette-divider);
  align-self: stretch;
  height: auto;
}

.withText {
  display: flex;
  align-items: center;
  gap: 16px;
  border: none;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
  text-transform: uppercase;
}

.withText::before,
.withText::after {
  content: '';
  flex: 1;
  border-bottom: thin solid var(--tuna-palette-divider);
}
